import { render, staticRenderFns } from "./opening-hours.vue?vue&type=template&id=599bd5ba&"
import script from "./opening-hours.vue?vue&type=script&lang=js&"
export * from "./opening-hours.vue?vue&type=script&lang=js&"
import style0 from "./opening-hours.vue?vue&type=style&index=0&id=599bd5ba&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports